<template>
    <div class="music-play" @click="playMusicAudio($event)">
        <AudioPlayer :audio-list="audioList" :show-play-button="true" :show-prev-button="false" :show-next-button="false" :show-progress-bar="false" :isLoop="true" />
    </div>
</template>
<style>
.music-play{
    width: 40%;
    height: 40px;
    position: absolute;
    left: 30%;
    bottom: 0;
}
.music-play .audio-player .audio__btn-wrap .audio__play__icon {
    width: 100%;
    height: 100%;
    color: transparent;
    /* color:red;  */
}
.music-play .audio-player .audio__btn-wrap .audio__play--pause,
.audio-player .audio__btn-wrap .audio__play--start {
    z-index: 1;
    width: 100%;
    height: 40px;
    margin: 0;
}

</style>
<script>
import { AudioPlayer } from '@liripeng/vue-audio-player';
import '@liripeng/vue-audio-player/lib/vue-audio-player.css';

export default {
    components: {
        AudioPlayer,
    },
    props: ['audio', 'musicIndex'],
    data() {
        return {
            audioList: Array.of(this.audio),
            isPlayMusic: false,
            idx: this.musicIndex,
        };
    },
    methods: {
        playMusicAudio(e) {
            this.$emit('markMusicIndex',this.idx)
            // 控制音乐播放
            this.isPlayMusic = !this.isPlayMusic;
            let that = this;
            // 所有的麦克风置为斜杠状态
            this.$emit('banAllMicroPhone');
            // 获取所有audios
            let audios = document.getElementsByTagName('audio');
            let currentAudio = e.currentTarget.getElementsByTagName('audio');
            if (this.isPlayMusic == true) {
              // 记录背景音乐
                this.$emit('MarkBackgroundMusic', currentAudio[0], this.idx);
            } else if (this.isPlayMusic == false) {
              // 清除背景音乐
                this.$emit('clearnBackgroundMusic',this.idx);
            }
            // 暂停函数
            function pauseAlls() {
                let self = this;
                [].forEach.call(audios, function(i, curIndex) {
                    // 将audios中其他的audio全部暂停
                    if (i !== self) {
                        i.pause();
                    } else {
                        i.play();
                    }
                });
            }

            // 给play事件绑定暂停函数
            [].forEach.call(audios, function(i, curIndex) {
                i.addEventListener('play', pauseAlls.bind(i));
            });
        },
    },
};
</script>
